// GATE-01-A (agent-logs/runs/2026-09-11-spec-219-offers/evidence/
// human-resolution-gate-01-dup-and-format.json): `addInclude`/`removeInclude`/
// `updateInclude` eran las mismas tres funciones, palabra por palabra, en
// benefits/BenefitsScreen.tsx y offers/OffersScreen.tsx — ambas operan sobre
// el mismo campo `includes: {textEs, textEn}[]` del formulario. Se extrae el
// comportamiento (este hook) separado del marcado (`IncludesFieldGroup`)
// porque cada pantalla sigue llamando a su propio `setValue` tipado contra su
// propio `FormValues`. Extracción sin cambio de comportamiento: mismas
// mutaciones, mismo `shouldDirty: true` en el llamador.
export interface IncludeItem {
  textEs: string;
  textEn: string;
}

export function useIncludesField(
  items: IncludeItem[],
  onChange: (next: IncludeItem[]) => void,
) {
  const addItem = () => {
    onChange([...items, { textEs: "", textEn: "" }]);
  };
  const removeItem = (index: number) => {
    onChange(items.filter((_, i) => i !== index));
  };
  const updateItem = (
    index: number,
    field: "textEs" | "textEn",
    value: string,
  ) => {
    onChange(
      items.map((item, i) =>
        i === index ? { ...item, [field]: value } : item,
      ),
    );
  };
  return { addItem, removeItem, updateItem };
}
